import './style.scss'
import Layer from '../../../../../Shared/Layer'
import { Col, Container, Row } from '@trendmicro/react-grid-system'
import Button from '../../../../../Shared/Form/Button'
import { useTranslation } from 'react-i18next'
import { BUTTON_MIN_WIDTH } from '../../../../../Shared/Form/Button/constants'

const ImagesConfirmedSuccessfullyOverlay = ({ onCancel }) => {
  const { t } = useTranslation()
  return (
    <Layer
      type="center"
      size="small"
      id={'images-confirmed'}
      show={true}
      onHideClick={onCancel}
      background="light-grey"
      borderRadius="20px"
      showCloseIcon={false}
      className="images-confirmed-notice-overlay"
      closeOnEsc={true}
    >
      <Container fluid>
        <Row style={{ alignItems: 'center' }}>
          <Col xs={3}>
            <span className="images-confirmed-notice-overlay__save_icon"></span>
          </Col>
          <Col xs={9}>
            <span className="images-confirmed-notice-overlay__header">{t('IMAGES_CONFIRMED_SUCCESSFULLY')}</span>
            &nbsp;
            <span className="images-confirmed-notice-overlay__subheader">
              {t('IMAGES_CONFIRMED_NOTICE_SUBHEADER')}
            </span>
          </Col>
        </Row>
        <Row style={{ textAlign: 'center' }}>
          <Col>
            <Button onClick={onCancel} style={{ textTransform: 'uppercase' }}
                    minWidth={BUTTON_MIN_WIDTH}>{t('BUTTON_OK')}</Button>
          </Col>
        </Row>
      </Container>
    </Layer>
  )
}

export default ImagesConfirmedSuccessfullyOverlay
